import React, { useState, useEffect } from 'react';
import { usePubStyles, PubNav, PubFooter, PubPage } from './PublicLayout';

interface Props {
  onNavigate: (page: PubPage) => void;
}

const CAROUSEL = [
  { img: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1400&h=700&fit=crop&q=85', h2: 'Wealth Management Excellence', p: 'Ranked #1 Private Bank in North America by Euromoney for 3 consecutive years.' },
  { img: 'https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=1400&h=700&fit=crop&q=85', h2: 'Global Investment Portfolio',   p: 'Managing over $800 billion in discretionary mandates across 60 asset classes.' },
  { img: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=1400&h=700&fit=crop&q=85', h2: 'Infrastructure & Real Assets',  p: 'Leading financier of renewable energy with $45B in green bonds issued since 2019.' },
];

const FILTERS = ['All', 'Private Equity', 'Real Estate', 'Technology', 'Infrastructure', 'Green Finance'];

const PROJECTS = [
  { tag: 'Real Estate',    name: 'The Hudson Tower',       meta: 'New York · $1.2B',           img: 'https://images.unsplash.com/photo-1486325212027-8081e485255e?w=800&h=600&fit=crop&q=80', large: true },
  { tag: 'Technology',     name: 'FinTech Ventures III',   meta: '$450M · 24 Companies',        img: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=600&h=450&fit=crop&q=80' },
  { tag: 'Green Finance',  name: 'Solar Grid Initiative',  meta: 'Texas · 2.4GW',               img: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=600&h=450&fit=crop&q=80' },
  { tag: 'Infrastructure', name: 'TransAtlantic Fiber',    meta: 'Atlantic Ocean · $3.8B',      img: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=600&h=450&fit=crop&q=80', large: true },
  { tag: 'Private Equity', name: 'Healthcare Growth Fund', meta: '18 Companies · $680M',        img: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600&h=450&fit=crop&q=80' },
  { tag: 'Real Estate',    name: 'Dubai Marina Complex',   meta: 'UAE · Mixed Use · $890M',     img: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=600&h=450&fit=crop&q=80' },
];

const AWARDS = [
  { icon: '🏆', year: '2025', name: 'Best Digital Bank — Americas',     body: 'Global Finance Magazine' },
  { icon: '🥇', year: '2024', name: 'Most Innovative Bank',             body: 'The Banker Awards' },
  { icon: '⭐', year: '2024', name: 'Best Private Bank — North America', body: 'Euromoney' },
  { icon: '🌱', year: '2023', name: 'Green Finance Leader',              body: 'Environmental Finance' },
  { icon: '🔐', year: '2023', name: 'Cybersecurity Excellence',          body: 'Banking Technology Awards' },
  { icon: '💼', year: '2022', name: 'Best Wealth Manager',               body: 'PWM / FT' },
];

const PORTFOLIO_STYLES = `
.pf-carousel { position: relative; overflow: hidden; border-radius: 20px; }
.pf-carousel-track { display: flex; transition: transform .5s cubic-bezier(.4,0,.2,1); }
.pf-carousel-slide { min-width: 100%; aspect-ratio: 16/8; position: relative; }
.pf-carousel-slide img { width: 100%; height: 100%; object-fit: cover; display: block; }
.pf-carousel-overlay { position: absolute; inset: 0; background: linear-gradient(to right, rgba(6,10,20,.82) 38%, transparent); }
.pf-carousel-caption { position: absolute; bottom: 44px; left: 52px; max-width: 500px; }
.pf-carousel-caption h2 { font-family: 'Cormorant Garamond', serif; font-size: 34px; font-weight: 300; margin-bottom: 10px; }
.pf-carousel-caption p { font-size: 14px; color: rgba(255,255,255,.72); line-height: 1.65; }
.pf-carousel-controls { position: absolute; bottom: 44px; right: 44px; display: flex; gap: 8px; }
.pf-carousel-btn { width: 42px; height: 42px; border-radius: 50%; background: rgba(255,255,255,.1); border: 1px solid rgba(255,255,255,.2); color: white; font-size: 16px; cursor: pointer; backdrop-filter: blur(10px); transition: all .2s; display: flex; align-items: center; justify-content: center; }
.pf-carousel-btn:hover { background: rgba(201,168,76,.3); border-color: var(--gold); }
.pf-carousel-dots { position: absolute; bottom: 18px; left: 50%; transform: translateX(-50%); display: flex; gap: 8px; }
.pf-carousel-dot { width: 6px; height: 6px; border-radius: 50%; background: rgba(255,255,255,.3); cursor: pointer; transition: all .3s; }
.pf-carousel-dot.active { width: 24px; border-radius: 3px; background: var(--gold); }

.pf-filter-btn { padding: 8px 22px; border-radius: 100px; border: 1px solid var(--border); background: transparent; color: var(--muted); font-size: 13px; font-family: 'DM Sans', sans-serif; cursor: pointer; transition: all .2s; }
.pf-filter-btn:hover { border-color: rgba(201,168,76,.3); color: var(--text); }
.pf-filter-btn.active { background: var(--gold); border-color: var(--gold); color: #080d1a; font-weight: 600; }

.pf-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 20px; }
.pf-item { border-radius: 20px; overflow: hidden; cursor: pointer; transition: transform .3s; position: relative; }
.pf-item:hover { transform: translateY(-6px); }
.pf-item.large { grid-column: span 2; }
.pf-item img { width: 100%; aspect-ratio: 4/3; object-fit: cover; display: block; }
.pf-item.large img { aspect-ratio: 16/9; }
.pf-item-overlay { position: absolute; inset: 0; background: linear-gradient(to top, rgba(6,10,20,.92) 38%, transparent); display: flex; flex-direction: column; justify-content: flex-end; padding: 24px; opacity: 0; transition: opacity .3s; }
.pf-item:hover .pf-item-overlay { opacity: 1; }
.pf-item-tag { font-size: 10px; color: var(--gold); letter-spacing: 1px; text-transform: uppercase; margin-bottom: 6px; }
.pf-item-name { font-family: 'Cormorant Garamond', serif; font-size: 22px; font-weight: 400; }
.pf-item-meta { font-size: 12px; color: rgba(255,255,255,.62); margin-top: 4px; }

.award-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 20px; }
.award-card { background: var(--navy2); border: 1px solid var(--border); border-radius: 16px; padding: 24px; display: flex; gap: 16px; align-items: flex-start; }
.award-icon { font-size: 28px; flex-shrink: 0; }
.award-year { font-size: 10px; color: var(--gold); letter-spacing: 1px; text-transform: uppercase; margin-bottom: 4px; }
.award-name { font-size: 13px; font-weight: 500; line-height: 1.4; }
.award-body { font-size: 11px; color: var(--muted); margin-top: 4px; }

@media (max-width: 900px) {
  .pf-grid, .award-grid { grid-template-columns: 1fr 1fr; }
  .pf-item.large { grid-column: span 1; }
  .pf-carousel-caption { left: 24px; bottom: 24px; }
  .pf-carousel-controls { bottom: 24px; right: 24px; }
}
@media (max-width: 600px) {
  .pf-grid, .award-grid { grid-template-columns: 1fr; }
  .pf-item.large { grid-column: span 1; }
}
`;

function injectPortfolioStyles() {
  if (document.getElementById('pf-styles')) return;
  const s = document.createElement('style');
  s.id = 'pf-styles';
  s.textContent = PORTFOLIO_STYLES;
  document.head.appendChild(s);
}

export default function PortfolioPage({ onNavigate }: Props) {
  usePubStyles();
  useEffect(() => { injectPortfolioStyles(); }, []);

  const [slide, setSlide] = useState(0);
  const [filter, setFilter] = useState('All');

  useEffect(() => {
    const t = setInterval(() => setSlide(s => (s + 1) % CAROUSEL.length), 5000);
    return () => clearInterval(t);
  }, []);

  const filtered = filter === 'All' ? PROJECTS : PROJECTS.filter(p => p.tag === filter);

  return (
    <div className="pub-page">
      <PubNav current="portfolio" onNavigate={onNavigate} />

      {/* ── Hero ── */}
      <div className="pub-wrap" style={{ padding: '80px 60px 32px' }}>
        <div className="pub-eyebrow">◆ Our Work</div>
        <h1 className="pub-h1">A legacy of <em style={{ color: 'var(--gold)', fontStyle: 'italic' }}>impact</em></h1>
        <p className="pub-p" style={{ maxWidth: 600 }}>
          From landmark real estate to clean energy and frontier technology — our investment portfolio spans
          the industries shaping tomorrow's global economy.
        </p>
      </div>

      {/* ── Carousel ── */}
      <div className="pub-wrap" style={{ marginBottom: 60 }}>
        <div className="pf-carousel">
          <div className="pf-carousel-track" style={{ transform: `translateX(-${slide * 100}%)` }}>
            {CAROUSEL.map((sl, i) => (
              <div key={i} className="pf-carousel-slide">
                <img src={sl.img} alt={sl.h2} />
                <div className="pf-carousel-overlay" />
                <div className="pf-carousel-caption">
                  <h2>{sl.h2}</h2>
                  <p>{sl.p}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="pf-carousel-controls">
            <button className="pf-carousel-btn" onClick={() => setSlide(s => (s - 1 + CAROUSEL.length) % CAROUSEL.length)}>←</button>
            <button className="pf-carousel-btn" onClick={() => setSlide(s => (s + 1) % CAROUSEL.length)}>→</button>
          </div>
          <div className="pf-carousel-dots">
            {CAROUSEL.map((_, i) => (
              <div key={i} className={`pf-carousel-dot${i === slide ? ' active' : ''}`} onClick={() => setSlide(i)} />
            ))}
          </div>
        </div>
      </div>

      {/* ── Stats ── */}
      <div className="pub-wrap">
        <div className="pub-stat-row">
          {[['$2.4T','AUM'],['180+','Countries'],['500+','Daily Transactions'],['$45B','Green Bonds Issued']].map(([v,l]) => (
            <div key={l} className="pub-stat-cell">
              <div className="pub-stat-val">{v}</div>
              <div className="pub-stat-lbl">{l}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ── Portfolio Grid ── */}
      <div className="pub-wrap pub-section">
        <div className="pub-eyebrow">Featured Investments</div>
        <h2 className="pub-h2" style={{ marginBottom: 24 }}>Selected <em style={{ color: 'var(--gold)', fontStyle: 'italic' }}>portfolio</em></h2>

        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 36 }}>
          {FILTERS.map(f => (
            <button key={f} className={`pf-filter-btn${filter === f ? ' active' : ''}`} onClick={() => setFilter(f)}>{f}</button>
          ))}
        </div>

        <div className="pf-grid">
          {filtered.map(p => (
            <div key={p.name} className={`pf-item${p.large ? ' large' : ''}`}>
              <img src={p.img} alt={p.name} />
              <div className="pf-item-overlay">
                <div className="pf-item-tag">{p.tag}</div>
                <div className="pf-item-name">{p.name}</div>
                <div className="pf-item-meta">{p.meta}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ── Awards ── */}
      <div className="pub-dark">
        <div className="pub-wrap pub-section">
          <div className="pub-eyebrow">Recognition</div>
          <h2 className="pub-h2" style={{ marginBottom: 36 }}>Awards & <em style={{ color: 'var(--gold)', fontStyle: 'italic' }}>accolades</em></h2>
          <div className="award-grid">
            {AWARDS.map(a => (
              <div key={a.name} className="award-card">
                <div className="award-icon">{a.icon}</div>
                <div>
                  <div className="award-year">{a.year}</div>
                  <div className="award-name">{a.name}</div>
                  <div className="award-body">{a.body}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── CTA ── */}
      <div className="pub-cta-banner">
        <h2>Explore investment opportunities</h2>
        <p>Join 4.2 million clients who trust Nationstar to grow and protect their wealth.</p>
        <div className="pub-cta-btns">
          <button className="pub-btn-gold" onClick={() => onNavigate('landing')}>Get Started →</button>
          <button className="pub-btn-ghost" onClick={() => onNavigate('contact')}>Talk to an Advisor</button>
        </div>
      </div>

      <PubFooter onNavigate={onNavigate} />
    </div>
  );
}
